import React, { useState, useEffect } from 'react';
import { useTitle } from '../../../context/TitleContext';
import { useParams, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaArrowLeft, FaSave, FaTags } from 'react-icons/fa';
import { showSuccessToast, showErrorToast } from '../../../shared/utils/toastHelper';
import apiClient from '../../../shared/utils/apiConfig';

const AdminSubSubCategoryAdd = () => {
    const { setTitle } = useTitle();
    const { subCategoryId } = useParams();
    const navigate = useNavigate();
    
    const [formData, setFormData] = useState({
        subcategory_id: subCategoryId,
        name_ar: '',
        name_en: ''
    });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setTitle('إضافة فئة فرعية جديدة');
    }, [setTitle]);

    useEffect(() => {
        // تحديث subcategory_id عند تغيير subCategoryId
        setFormData(prev => ({
            ...prev,
            subcategory_id: subCategoryId
        }));
    }, [subCategoryId]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!formData.name_ar.trim() || !formData.name_en.trim()) {
            showErrorToast('يرجى ملء الاسم بالعربية والإنجليزية');
            return;
        }

        try {
            setLoading(true);
            
            await apiClient.post('/admin/sub_category/sub-sub-categories', formData);
            
            showSuccessToast('تم إضافة الفئة الفرعية بنجاح');
            navigate(`/admin-categories/${subCategoryId}/sub-sub-categories`);
        } catch (error) {
            showErrorToast(error.response?.data?.message || 'فشل في إضافة الفئة الفرعية');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="main_content">
            <div className="dashboard-container">
                {/* Header */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="d-flex align-items-center">
                        <motion.button
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            className="btn btn-outline-secondary mx-3"
                            onClick={() => navigate(`/admin-categories/${subCategoryId}/sub-sub-categories`)}>
                            <FaArrowLeft className="mx-2" />
                            العودة
                        </motion.button>
                    </div>
                </div>

                {/* Form */}
                <div className="card shadow-lg border-0">
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-6 mb-4">
                                    <label className="form-label">
                                        <FaTags className="mx-2" />
                                        الاسم (عربي) *
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="name_ar"
                                        value={formData.name_ar}
                                        onChange={handleInputChange}
                                        placeholder="أدخل الاسم باللغة العربية..."
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mb-4">
                                    <label className="form-label">
                                        <FaTags className="mx-2" />
                                        الاسم (إنجليزي) *
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="name_en"
                                        value={formData.name_en}
                                        onChange={handleInputChange}
                                        placeholder="Enter the name in English..."
                                        required
                                    />
                                </div>
                            </div>

                            <div className="d-flex justify-content-end gap-3">
                                <motion.button
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    type="button"
                                    className="btn btn-outline-secondary"
                                    onClick={() => navigate(`/admin-categories/${subCategoryId}/sub-sub-categories`)}>
                                    إلغاء
                                </motion.button>
                                <motion.button
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    type="submit"
                                    className="btn text-white d-flex align-items-center"
                                    style={{ backgroundColor: 'rgb(24, 65, 148)' }}
                                    disabled={loading}>
                                    {loading ? (
                                        <>
                                            <div className="spinner-border spinner-border-sm mx-2" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                            جاري الحفظ...
                                        </>
                                    ) : (
                                        <>
                                            <FaSave className="mx-2" />
                                            حفظ الفئة الفرعية
                                        </>
                                    )}
                                </motion.button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminSubSubCategoryAdd;
